<template>
  <div class="authorization-page">
    <div class="b-container fluid">
      <div class="b-row sign-in">
        <div class="container">
          <div class="row header">
            <div class="col-12">
              <h1 class="vertical-center">
                <img src="../assets/img/global/logo-sa-clearinghouse-white.png" alt="ClearingHouse" />
              </h1>
            </div>
          </div>
          <div class="row">
            <div class="message align-self-center d-none d-lg-block col-lg-6">
              <img
                class="img-fluid"
                src="../assets/img/home/home-sa-gift-of-christmas.png"
                alt="ClearingHouse logo"
              />
            </div>
            <div class="col-12 col-lg-6">
              <div class="sa-authenticator">
                <amplify-authenticator :auth-config="authConfig"></amplify-authenticator>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="sa-hometext mx-auto col-12 col-md-10">
          <strong>Welcome to The Salvation Army Clearing House!</strong>
          The Salvation Army Clearing House is an app intended to help facilitate agencies
          working together to service family needs by checking potential duplicate records
          across agencies. Your organization's data will only be utilized for checking
          duplicates across organizations and will only be viewable by you, save for duplicate cases between organizations.
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import metadata from '../util/metadata';

export default {
  name: 'CreateAccount',
  metaInfo: {
    title: `Home | ${metadata.GLOBAL.PAGE_TITLE}`,
    meta: [{ name: 'description', content: 'The home page in starter app' }]
  },
  props: [],
  data() {
    return {
      authConfig: {
        usernameAttributes: 'email',
        signInConfig: {
          isSignUpDisplayed : false
        }
      }
    };
  }
};
</script>

<style lang="scss">
@import "../styles/environment/_variables";
@import "../styles/mixins/mixins";

.authorization-page {
  .header {
    height: 100px;
  }

  .create-account {
    float: right;
  }

  .message {
    color: $sa-white;
  }

  .sign-in {
    background-image: url(../assets/img/home/sa-landing-page-ornament.jpg);
    min-height: 520px;
    background-size: cover;
    background-repeat: no-repeat;
  }

  [data-test="authenticator-error"],
  .error {
    color: $sa-red-dark;
    font-weight: bold;
    margin-top: 20px;
  }

  [data-test="sign-in-section"],
  [data-test="sign-up-section"],
  [data-test="forgot-password-section"],
  [data-test="require-new-password-section"],
  [data-test="confirm-sign-up-section"] {
    border-radius: 0;
    margin-bottom: 0;
    min-width: 100%;
  }

  .sa-authenticator {
    border: 1px solid rgba(255, 255, 255, 0.33);
    margin-bottom: 50px;
    margin-top: 50px;
    padding: 4px;

    > div {
      background-color: $sa-white;
    }

    a[data-test="sign-in-create-account-link"],
    a[data-test="sign-up-sign-in-link"] {
      color: $sa-red;
      text-decoration: underline;
    }

    button {
      @include button;
      font-size: $sa-btn-font-size;
      overflow: hidden;
      padding: 15px 25px;
      position: relative;
      text-transform: uppercase;
      transition: all 0.2s ease-out;

      &:hover {
        opacity: 1;
      }
    }
  }

  .sa-hometext {
    line-height: 35px;
    margin-top: 50px;
  }
}
</style>
